import React from "react";
import Tickicon from "../../assests/images/landing-page/tick.png";
import Checked from "../../assests/images/dashboard/Checkbox.png";

const PlanCard = ({ plan, index, onSelectPlan, selectedPlan }: any) => {
  const isSelected = selectedPlan?.priceId === plan.priceId;
  const description =
    index === 0
      ? "For individuals or teams just getting started with project management."
      : index === 1 || index === 2
        ? "For teams that need to create project plans with confidence."
        : "For teams and companies that need to manage work across initiatives.";

  return (
    <div
      className="w-full rounded-2xl border bg-white shadow-sm"
      key={index}
      style={{ borderColor: isSelected ? "#FD7657" : "#F1F1F2" }}
    >
      <div className="flex h-[min(62vh,720px)] min-h-[520px] flex-col p-6 md:p-8">
        <div key={index} className="relative flex min-h-0 flex-1 flex-col">
          <h1 className="pr-8 text-lg font-medium text-black">{plan?.tier?.toUpperCase()}</h1>
          {isSelected && <img src={Checked} alt="" className="absolute right-0 top-0 h-[20px] w-[20px]" />}
          <p className="mt-2 text-sm text-textColor">
            {description}
          </p>

          <h1 className="mt-4 text-lg font-medium text-black">
            ${plan.priceCents}/mth
          </h1>
          <div className="my-5 flex">
            <button
              style={{
                color: isSelected ? "#fff" : "#FD7657",
                backgroundColor: isSelected ? "#FD7657" : "#ffffff",
              }}
              className="h-[48px] w-full cursor-pointer rounded-xl border border-[#F1F1F2]"
              onClick={() => onSelectPlan(plan)}
            >
              Get Started
            </button>
          </div>
          <h1 className="text-lg font-medium text-black">
            {"Highlights of plan features:"}
          </h1>

          <div className="mt-4 min-h-0 flex-1 overflow-y-auto pr-2">
            <div className="space-y-2 text-sm text-textColor">
              {plan.features.map((feature: any, featureIndex: number) => (
                <div key={featureIndex} className="flex items-start">
                  <img src={Tickicon} alt="" className="mt-1 shrink-0" />
                  <span className="ml-3 leading-6">{feature}</span>
                </div>
              ))}
            </div>
            <div className="h-4" />
          </div>

          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-8 rounded-b-2xl bg-gradient-to-t from-white to-transparent" />
          <div className="mt-3 text-xs text-[#98A2B3]">
            Scroll to view all features
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
